export const REDUCER_KEY = 'publication-summary';
export const GROUP_STATUS_ACTIVE = 'ACTIVE';
export const GROUP_STATUS_WILL_ACTIVATE = 'WILL_ACTIVATE';
export const GROUP_STATUS_INACTIVE = 'INACTIVE';
export const GROUP_STATUS_PREPARING = 'PREPARING';
